module.exports = {
  name: "Joe Blob",
  email: "joe@blob.com",
  company: "Blob and Son",
  account: "business"
};
